import { ActionSource } from 'owa-mail-store';

export default {
    MailComposeNew: {
        name: 'MailComposeNew',
        options: {},
        customData: (actionSource: ActionSource) => [
            actionSource,
            false /* custom data is dead now, as tab view is always enabled */,
        ],
    },
};
